export default "__VITE_ASSET__dI9xv2cx__"